import * as _4 from 'lodash4';
import { ResolutionType } from '../builders/resolution_types_builder';

interface IBuiltUrlForResolutions {
  linkingAddress: string;
  prettyAddress: string;
}

export interface IHoldsResolution {
  icon: string;
  desktopActionable: boolean;
  description: string;
  link: {
    desktop: string;
    android: string;
    ios: string;
  };
}

// TODO: refactor to use utility-ts-strategy
export class HoldsResolutionServant {
  static build(resolution: ResolutionType) {
    return this[resolution.channel](resolution);
  }

  static WEB(resolution: ResolutionType): IHoldsResolution {
    return this.URL(resolution);
  }

  static URL(resolution: ResolutionType): IHoldsResolution {
    const { contact_display_value, contact_value } = resolution;
    const desktopActionable = true;
    const icon = 'link';
    const urls = this.__constructURL(contact_value);
    const description = this.__setDescription(urls.prettyAddress, contact_display_value);
    const link = {
      desktop: urls.linkingAddress,
      android: urls.linkingAddress,
      ios: urls.linkingAddress
    };

    return { description, link, desktopActionable, icon };
  }

  static LOCATION(resolution: ResolutionType): IHoldsResolution {
    const { contact_value, contact_display_value } = resolution;
    const icon = 'map_marker';
    const description = this.__setDescription(contact_value, contact_display_value);

    // TODO: figure out how the server handles long/lat and revisit this code
    // let addressAppend;
    // if (!_.isEmpty(processingResolution.source.address)) {
    //   addressAppend = processingResolution.source.address;
    // } else if (processingResolution.source.longitude !== 0 && processingResolution.source.latitude !== 0) {
    //   addressAppend = processingResolution.source.latitude + ',' + processingResolution.source.longitude;
    // }

    const link = {
      desktop: 'https://maps.google.com/?q=' + contact_value,
      android: 'geo://maps.google.com/?q=' + contact_value,
      ios: 'maps://maps.apple.com/?q=' + contact_value
    };

    const desktopActionable = true;

    return { description, link, desktopActionable, icon };
  }

  static PHONE(resolution: ResolutionType): IHoldsResolution {
    return this.__simpleResolutionConstruction('tel://', resolution, 'telephone');
  }

  static EMAIL(resolution: ResolutionType): IHoldsResolution {
    return this.__simpleResolutionConstruction('mailto:', resolution, 'envelope');
  }

  // function methods we use to clean up the meat of the methods
  private static __constructURL(url: string): IBuiltUrlForResolutions {
    const urlPrefixExpression = new RegExp('://');
    let prettyAddress = url;

    const urlContainsPrefix = urlPrefixExpression.exec(prettyAddress) as RegExpExecArray;
    let linkingAddress = '';

    if (_4.isNull(urlContainsPrefix)) {
      linkingAddress = 'http://' + prettyAddress;
    } else {
      linkingAddress = prettyAddress;

      // regex has the starting index stored, but we add 3 since the expression is 3 characters long
      prettyAddress = prettyAddress.slice(urlContainsPrefix.index + 3, prettyAddress.length);
    }

    /* tslint:disable-next-line */
    return { prettyAddress, linkingAddress } as IBuiltUrlForResolutions;
  }

  private static __simpleResolutionConstruction(prefix: string, resolution: ResolutionType, icon: string) {
    const { contact_value, contact_display_value } = resolution;
    const description = this.__setDescription(contact_value, contact_display_value);
    const link = {
      desktop: prefix + contact_value,
      android: prefix + contact_value,
      ios: prefix + contact_value
    };
    const desktopActionable = false;

    return { description, link, desktopActionable, icon };
  }

  private static __setDescription(value: string, displayValue: string): string {
    return _4.isEmpty(displayValue) ? value : displayValue;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-holds/src/servants/holds_resolution_servant.ts